function Painting (id, pos, name, direction) {
  this.id = id
  this.position = pos
  this.name = name
  this.direction = direction
}
module.exports = Painting
